import {Box,Typography} from '@mui/material';
import COMPONENT_MAP from '../Repository/Components.js';
import BatchDetailManufacturingOrders from '../Batch/BatchDetailManufacturingOrders.js';

const TankDetailBatchPopup=({popupCallBack,rowId,parent,userData,application})=>{
    const pageCallback=async(action,args)=>{
        popupCallBack(action,args);
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'Batch'}
                entityParams={[
                    '_context='+[
                        'parent_field_name='+parent.parent_field_name,
                        'parent_field_value='+parent.parent_field_value,
                        'parent_name='+parent.parent_name,
                        ...(!rowId && parent.preDefaults?.start_date ? ['start_date='+parent.preDefaults.start_date] : []),
                    ].join(","),
                    '_lang=' + application.globalData.lang,
                ]}
                file={'TankDetailBatchPopup.js'}
                titleLabel={rowId?application.getLocale("PageTabBatch"):application.getLocale("PageTabNewBatch")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                openOnUpdate={true}
                extraPopupContent={(batchId,row)=>batchId?
                    <Box sx={{mt:2,pt:1,borderTop:'1px solid',borderColor:'divider'}}>
                        <Typography variant="subtitle2" fontWeight="bold" sx={{mb:1}}>{application.getLocale("PageTabManufacturingOrders")}</Typography>
                        <BatchDetailManufacturingOrders parentId={batchId} parent={row} application={application} userData={userData} fromPopup={true}/>
                    </Box>
                    :null}
            />
        ):null;
    };
    return (renderPageDetail());
}

export default TankDetailBatchPopup;
